// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-footer[data-v-2d2a89b6] {
  display: block;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./public/pages/dialogs/SubmitFailure.3.vue","webpack://./../SubmitFailure.3.vue"],"names":[],"mappings":"AACA;EACI,cAAA;EACA,kBAAA;ACAJ","sourcesContent":["\n.modal-footer {\n    display: block;\n    text-align: center;\n}\n",".modal-footer {\n  display: block;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
